// @ts-nocheck
import { GetTrailerTrackingsV2ApiParameter } from "@store/Framework/Services/TrailerServiceV2";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetTrailerTrackingsV2ApiParameter>;

export const DispatchSetParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/SetParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetParameter];

const setParameter = createHandlerChainRunner(chain, "SetParameter");
export default setParameter;
